import { createSlice } from "@reduxjs/toolkit";


const orderSlice = createSlice({
    name: 'Order',
    initialState: {
        loading: false,
        order: null,
        error: null,
        orders: []
    },
    reducers: {
        createOrderRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        createOrderSuccess(state, action) {
            return {
                ...state,
                loading: false,
                order: action.payload
            }
        },
        createOrderFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        getOrdersRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        getOrdersSuccess(state, action) {
            return {
                ...state,
                loading: false,
                orders: action.payload.orders,
            }
        },
        getOrdersFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },

    }
});

const { actions, reducer } = orderSlice;

export const {
    createOrderRequest,
    createOrderSuccess,
    createOrderFail,
    getOrdersRequest,
    getOrdersSuccess,
    getOrdersFail
} = actions;

export default reducer;
